<div class="top">
  <div layout layout-align-items-center>
    @if (ticket().symbol; as symbol) {
      <rt-symbol [symbol]="symbol" margin-right-small-x />
    }
    <rt-heading>
      <span class="template-name">{{ ticket().name }}</span>
    </rt-heading>
  </div>
  <div class="requester" text-small>
    <span text-weight-semi-bold>{{ requesterName() }}</span>
    @if (ticket().priority; as priority) {
      <rt-divider variant="dot" />
      <rt-icon name="flag" [colorToken]="priorityColorMap[priority]" />
    }
  </div>
</div>

<rt-divider />
<div class="bottom" text-small-x>
  @if (assignees().length) {
    <span margin-right-small-x>
      {{ 'tlc.ask_hr.requests.assigned_to' | translate }}
    </span>
    <rt-admins-avatars [admins]="assignees()" [stacked]="true" [limit]="5" />
  } @else {
    <span>
      {{ 'tlc.ask_hr.requests.not_assigned' | translate }}
    </span>
  }

  <div
    [rtTooltip]="ticket().createdAt | amDateFormat: 'lll'"
    margin-left-auto
    layout
    layout-align-items-center
  >
    <rt-icon name="access-time" margin-right-small-xx />
    <span>
      {{ ticket().createdAt | rtTimeAgo: { omitSuffix: true } }}
    </span>
  </div>
</div>
